var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.defaultDeviceSetting.title))])],1),_c('v-list-item-action',[_c('v-checkbox',{attrs:{"loading":_vm.processing,"disabled":_vm.processing},on:{"change":_vm.valueChanged},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }